const defaultConfig = {
  accept: '',
  maxSize: 100000000, // 100MB in bytes
  maxFiles: 0,
  disabled: false,
  noDrag: true,
  noClick: true,
  validator: null,
  onDrop: null,
};

export default defaultConfig;
